import React from 'react';
import { BaseIcon } from '../../base/BaseIcon';
import { IconProps } from '../../types';

export const HierLnoVisibleIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M23.42 11.1C22.92 10.87 22.33 11.08 22.09 11.58C21.97 11.84 18.97 18 12 18C10.53 18 9.25001 17.72 8.13001 17.29L22.71 2.71001C23.1 2.32001 23.1 1.69001 22.71 1.30001C22.32 0.910007 21.69 0.910007 21.3 1.30001L6.25001 16.35C3.34001 14.5 1.99001 11.76 1.91001 11.59C1.68001 11.09 1.08001 10.87 0.580006 11.11C0.0800061 11.34 -0.139994 11.94 0.100006 12.44C0.190006 12.64 1.64001 15.64 4.80001 17.81L1.30001 21.31C0.910006 21.7 0.910006 22.33 1.30001 22.72C1.69001 23.11 2.32001 23.11 2.71001 22.72L6.60001 18.83C8.11001 19.54 9.90001 20.01 12.01 20.01C20.28 20.01 23.77 12.74 23.92 12.43C24.15 11.93 23.94 11.34 23.44 11.1H23.42Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

HierLnoVisibleIcon.displayName = 'HierLnoVisibleIcon';
